module.exports = __webpack_public_path__ + "img/pt-2.20374556.jpg";